import type { Module } from 'vuex';
import { UserAgent } from '@/types/UserAgent';
import { UserAgentExchangePair } from '@/types/UserAgentExchangePair';
import { UserAgentSetting } from '@/types/UserAgentSetting';
import {RootState} from "@/store";

export interface UserAgentState {
  userAgents: UserAgent[];
}

const userAgentModule: Module<UserAgentState, RootState> = {
  namespaced: true,

  state: () => ({
    userAgents: [],
  }),

  mutations: {
    setUserAgents(state, payload) {
      state.userAgents = Object.values(payload.userAgents).map(UserAgent.fromRaw);
    },

    setUserAgentCreate(
      state: UserAgentState,
      payload: {
        idUserAgent: number;
        idUserAccount: number;
        idAgent: number;
        userAgentExchangePairs: any[];
        userAgentSettings: any[];
      }
    ) {
      const raw = {
        idUserAgent: payload.idUserAgent,
        idUserAccount: payload.idUserAccount,
        idAgent: payload.idAgent,
        locked: false,
        userAgentExchangePairs: payload.userAgentExchangePairs,
        userAgentSettings: payload.userAgentSettings,
      };

      const userAgent = UserAgent.fromRaw(raw);
      state.userAgents.push(userAgent);
    },

    setUserAgentUpdate(
      state: UserAgentState,
      payload: {
        idUserAgent: number;
        userAgentExchangePairs: any[];
        userAgentSettings: any[];
      }
    ) {
      const userAgent = state.userAgents.find(userAgent => userAgent.idUserAgent === payload.idUserAgent);
      if (!userAgent) return;

      userAgent.exchangePairs = payload.userAgentExchangePairs.map(pair => 
        new UserAgentExchangePair(
          pair.idUserAgentExchangePair,
          pair.idUserAgent,
          pair.idExchangePair,
        )
      );
      
      userAgent.settings = payload.userAgentSettings.map(setting => 
        new UserAgentSetting(
          setting.idUserAgentSetting,
          setting.idUserAgent,
          setting.idAgentSetting,
          setting.value,
        )
      );
    },

    setUserAgentDelete(state: UserAgentState, payload: { idUserAgent: number }) {
      state.userAgents = state.userAgents.filter(userAgent => userAgent.idUserAgent !== payload.idUserAgent);
    },

    setUserAgentLock(state: UserAgentState, payload: { idUserAgent: number }) {
      const userAgent = state.userAgents.find(userAgent => userAgent.idUserAgent === payload.idUserAgent);
      if (userAgent) {
        userAgent.locked = true;
      }
    },

    setUserAgentUnlock(state: UserAgentState, payload: { idUserAgent: number }) {
      const userAgent = state.userAgents.find(userAgent => userAgent.idUserAgent === payload.idUserAgent);
      if (userAgent) {
        userAgent.locked = false;
      }
    },
  },
  actions: {
    wsSetUserAgents(context, payload) {
      context.commit('setUserAgents', payload);
    },
    wsUserAgentCreate(context, payload) {
      context.commit('setUserAgentCreate', payload);
    },
    wsUserAgentUpdate(context, payload) {
      context.commit('setUserAgentUpdate', payload);
    },
    wsUserAgentDelete(context, payload) {
      context.commit('setUserAgentDelete', payload);
    },
    wsUserAgentLock(context, payload) {
      context.commit('setUserAgentLock', payload);
    },
    wsUserAgentUnlock(context, payload) {
      context.commit('setUserAgentUnlock', payload);
    },
  },
};

export default userAgentModule;
